export default __webpack_public_path__ + "static/media/image-jcb.3362037c.svg";